// Curated landing-page demo data, intentionally independent from the listone.
export default Object.freeze([
  {
    ID_Club: 2,
    ID_Ruolo: "2",
    calciatore: "Bremer",
    imgCalciatore:
      "https://fpz.s3.eu-west-1.amazonaws.com/files/public/schede_calciatori/avatar/reali/juventusbremer.webp",
    nomeClub: "Juventus",
    quotazione: 8,
  },
  {
    ID_Club: 5,
    ID_Ruolo: "3",
    calciatore: "Kone M.",
    imgCalciatore:
      "https://fpz.s3.eu-west-1.amazonaws.com/files/public/schede_calciatori/avatar/reali/romakone.webp",
    nomeClub: "Roma",
    quotazione: 22,
  },
  {
    ID_Club: 1,
    ID_Ruolo: "4",
    calciatore: "Martinez L.",
    imgCalciatore:
      "https://fpz.s3.eu-west-1.amazonaws.com/files/public/schede_calciatori/avatar/reali/interlautaro.webp",
    nomeClub: "Inter",
    quotazione: 80,
  },
  {
    ID_Club: 3,
    ID_Ruolo: "4",
    calciatore: "Kean",
    imgCalciatore:
      "https://fpz.s3.eu-west-1.amazonaws.com/files/public/schede_calciatori/avatar/reali/fiorentinakean.webp",
    nomeClub: "Fiorentina",
    quotazione: 54,
  },
  {
    ID_Club: 4,
    ID_Ruolo: "3",
    calciatore: "Politano",
    imgCalciatore:
      "https://fpz.s3.eu-west-1.amazonaws.com/files/public/schede_calciatori/avatar/reali/napolipolitano.webp",
    nomeClub: "Napoli",
    quotazione: 25,
  },
  {
    ID_Club: 20,
    ID_Ruolo: "3",
    calciatore: "Zaccagni",
    imgCalciatore:
      "https://fpz.s3.eu-west-1.amazonaws.com/files/public/schede_calciatori/avatar/reali/laziozaccagni.webp",
    nomeClub: "Lazio",
    quotazione: 35,
  },
  {
    ID_Club: 17,
    ID_Ruolo: "3",
    calciatore: "Orsolini",
    imgCalciatore:
      "https://fpz.s3.eu-west-1.amazonaws.com/files/public/schede_calciatori/avatar/reali/bolognaorsolini.webp",
    nomeClub: "Bologna",
    quotazione: 51,
  },
  {
    ID_Club: 1,
    ID_Ruolo: "4",
    calciatore: "Thuram",
    imgCalciatore:
      "https://fpz.s3.eu-west-1.amazonaws.com/files/public/schede_calciatori/avatar/reali/interthuram.webp",
    nomeClub: "Inter",
    quotazione: 41,
  },
  {
    ID_Club: 7,
    ID_Ruolo: "3",
    calciatore: "Pulisic",
    imgCalciatore:
      "https://fpz.s3.eu-west-1.amazonaws.com/files/public/schede_calciatori/avatar/reali/milanpulisic.webp",
    nomeClub: "Milan",
    quotazione: 32,
  },
  {
    ID_Club: 4,
    ID_Ruolo: "3",
    calciatore: "McTominay",
    imgCalciatore:
      "https://fpz.s3.eu-west-1.amazonaws.com/files/public/schede_calciatori/avatar/reali/napolimctominay.webp",
    nomeClub: "Napoli",
    quotazione: 54,
  },
]);
